import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import type { EnrichedProfitabilityPeriod } from "@/profitability/types";
import { PeriodLink } from "./period-link";
import { RemovePeriod } from "./remove-col";
import { ReportResult } from "./result-col";
import { RunStatus } from "./run-status";

export const reportCol: ColumnDef<EnrichedProfitabilityPeriod> = {
  id: "period",
  header: "Report",
  accessorFn: (row) => row.start_date ?? row.display.period,
  cell: ({ row }) => (
    <Stack align="start" gap={3} className="min-w-0 py-4">
      <PeriodLink run={row.original} />
      <RunStatus run={row.original} />
      <ReportResult run={row.original} />
    </Stack>
  ),
};

/** The mobile row of a template's list, with the way to remove the period. */
export const reportRemoveCol: ColumnDef<EnrichedProfitabilityPeriod> = {
  ...reportCol,
  cell: ({ row }) => (
    <Stack align="start" gap={3} className="min-w-0 py-4">
      <PeriodLink run={row.original} />
      <RunStatus run={row.original} />
      <ReportResult run={row.original} />
      <RemovePeriod period={row.original} />
    </Stack>
  ),
};
